
import React, { useState, useEffect } from "react";

const Designitemagnet = (props) => {
  const [state, setState] = useState(props.currentValue);
  
  const calculatePrice = (qty, size) => {
    let price = 0.0;

    const smallMagnetPricing = [
      { min: 25, max: 49, price: 1.75 },
      { min: 50, max: 99, price: 1.60 },
      { min: 100, max: 249, price: 1.30 },
      { min: 250, max: 499, price: 1.10 },
      { min: 500, max: Infinity, price: 0.95 }
    ];

    const largeMagnetPricing = [
      { min: 25, max: 49, price: 2.25 },
      { min: 50, max: 99, price: 2.10 },
      { min: 100, max: 249, price: 1.85 },
      { min: 250, max: 499, price: 1.60 },
      { min: 500, max: Infinity, price: 1.40 }
    ];

    const pricingArray = size === "Small" ? smallMagnetPricing : largeMagnetPricing;
    const matchedTier = pricingArray.find(tier => qty >= tier.min && qty <= tier.max);
    if (matchedTier) {
      price = matchedTier.price * qty;
    }

    return price.toFixed(2);
  };

  const handleChange = (event, field) => {
    const value = event.target.value;
    let updatedDisplay = [...props.inputs.display_magnet];
    updatedDisplay[props.index][field] = value;

    if (field === "qty" || field === "size") {
      updatedDisplay[props.index].price = calculatePrice(
        updatedDisplay[props.index].qty,
        updatedDisplay[props.index].size
      );
    }

    props.setInputs((values) => ({ ...values, display_magnet: updatedDisplay }));
  };

  const generateOptions = () => {
    const options = [];
    for (let i = 25; i <= 500; i += 25) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };

  useEffect(() => {
    let updatedDisplay = [...props.inputs.display_magnet];
    updatedDisplay[props.index].size = "Small";
    updatedDisplay[props.index].qty = 25;
    updatedDisplay[props.index].magnet_size_type = "Wood"; 
    updatedDisplay[props.index].price = calculatePrice(25, "Small");
    props.setInputs((values) => ({ ...values, display_magnet: updatedDisplay }));
  }, []);

  return (

    <>
      <tr>

        <td>{props.index + 1}</td>
        <td>
          <select
            className="form-select"
            name="size"
            value={props.data.size}
            onChange={(e) => handleChange(e, "size")}
          >
            <option value="Small">Small (2"x2")</option>
            <option value="Large">Large (3"x3")</option>
          </select>
        </td>
        <td>
          <select
            className="form-select"
            name="magnet_size_type"
            value={props.data.magnet_size_type}
            onChange={(e) => handleChange(e, "magnet_size_type")}
          >
            <option value="Wood">Wood</option>
            <option value="Acrylic">Acrylic</option>
          </select>
        </td>
        <td>
          <select
            className="form-select"
            name="qty"
            value={props.data.qty}
            onChange={(e) => handleChange(e, "qty")}
          >
            {generateOptions()}
          </select>
        </td>
        <td>
          <input
            type="text"
            className="form-control"
            placeholder="Design Number"
            name="design_number"
            value={props.data.design_number}
            onChange={(e) => handleChange(e, "design_number")}
          />
        </td>
        <td>
          <input
            type="text"
            className="form-control"
            placeholder="Customization"
            name="customization"
            value={props.data.customization}
            onChange={(e) => handleChange(e, "customization")}
          />
        </td>
        <td className="text-center">
          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={() => props.deleteRow(props.index)}
          >
            ×
          </button>
        </td>
      </tr>

    </>
  );
};

export default Designitemagnet;
